import { cn } from '@/lib/utils'
import type { ComponentProps } from 'react'

/**
 * Junta botões em um bloco só: arredonda apenas as pontas e sobrepõe as bordas
 * internas, para que dois botões `outlined` vizinhos não desenhem uma linha
 * dupla no meio.
 *
 * O tamanho continua sendo do call-site — o grupo só cuida da emenda.
 */
export default function ButtonGroup({
    className,
    ...props
}: ComponentProps<'div'>) {
    return (
        <div
            role="group"
            className={cn(
                'inline-flex flex-row items-center',
                '*:rounded-none *:first:rounded-l-sm *:last:rounded-r-sm',
                '*:not-first:-ml-px',
                className,
            )}
            {...props}
        />
    )
}
